<template>
  <div>
    <div class="container" style="margin-top: 50px;">
      <h1 align="center">Select product portfolio</h1>
      <div class="row">
        <b-col lg="6" class="pb-2">
          <b-list-group size="sm">
            <b-list-group-item class="menu" v-for="menu in menus_left" v-bind:key="menu['text']">
              <b-button v-b-toggle="menu['id']" class="m-1" style="width:100%;">{{menu['text']}}</b-button>
              <b-collapse :id="menu['id']">
                <b-list-group-item
                  class="sub-menu"
                  v-for="sub_menu in menu.SubMenu"
                  v-bind:key="sub_menu.id"
                  :active="sub_menu.status"
                >
                  <li class="category-group-item" @click="clickSubMenu(sub_menu.id)" active>
                    <a style="user-select:none; padding-left: 10px;">{{sub_menu.text}}</a>
                  </li>
                </b-list-group-item>
              </b-collapse>
            </b-list-group-item>
          </b-list-group>
        </b-col>
        <b-col lg="6" class="pb-2">
          <b-list-group size="sm">
            <b-list-group-item class="menu" v-for="menu in menus_right" v-bind:key="menu['text']">
              <b-button v-b-toggle="menu['id']" class="m-1" style="width:100%;">{{menu['text']}}</b-button>
              <b-collapse :id="menu['id']">
                <b-list-group-item
                  class="sub-menu"
                  v-for="sub_menu in menu.SubMenu"
                  v-bind:key="sub_menu.id"
                  :active="sub_menu.status"
                >
                  <li class="category-group-item" @click="clickSubMenu(sub_menu.id)" active>
                    <a style="user-select:none; padding-left: 10px;">{{sub_menu.text}}</a>
                  </li>
                </b-list-group-item>
              </b-collapse>
            </b-list-group-item>
          </b-list-group>
        </b-col>
      </div>

      <b-row style="margin-top: 20px;">
        <div class="col-4">
          <b-button size="sm" @click="toBack()">Prev</b-button>
        </div>

        <div class="col-4" style="text-align:center">
          <!-- <b-button size="sm">Default Button</b-button> -->
        </div>
        <div class="col-4" style="text-align:right">
          <b-button size="sm" @click="toQuestion()">Next</b-button>
        </div>
      </b-row>
    </div>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      menus: [],
      menus_left: [],
      menus_right: [],
    };
  },
  mounted() {
    let vm = this;
    var parseString = require("xml2js").parseString;
    axios.get("/menu_portfolio.xml").then((response) => {
      var self = this;
      parseString(response.data, function (err, result) {
        // console.log(result.MenuRoot);
        // self.menus = result.MenuRoot;
        self.menus = [];
        var menu_cnt = 0;
        console.log(vm.$store.state.user.portfolios);
        for (var menu in result.MenuRoot.Menu) {
          var tmp_submenu = [];
          // console.log(result.MenuRoot.Menu[menu]['$']['text']);
          for (var sub_menu in result.MenuRoot.Menu[menu].SubMenu) {
            // console.log(result.MenuRoot.Menu[menu].SubMenu[sub_menu]['$']['text']);
            var portfolio_status = false;
            for(var i in vm.$store.state.user.portfolios)
            {
              if(vm.$store.state.user.portfolios[i] == result.MenuRoot.Menu[menu].SubMenu[sub_menu]["$"]["id"])
                portfolio_status = true;
            }
            tmp_submenu.push({
              id: result.MenuRoot.Menu[menu].SubMenu[sub_menu]["$"]["id"],
              text: result.MenuRoot.Menu[menu].SubMenu[sub_menu]["$"]["text"],
              status: portfolio_status,
            });
          }
          self.menus.push({
            id: result.MenuRoot.Menu[menu]["$"]["id"],
            text: result.MenuRoot.Menu[menu]["$"]["text"],
            SubMenu: tmp_submenu,
          });
          menu_cnt++;
        }
        // console.log(self.menus);

        for (var i = 0; i < menu_cnt / 2; i++) {
          self.menus_left.push(self.menus[i]);
        }
        for (var i = menu_cnt / 2; i < menu_cnt; i++) {
          self.menus_right.push(self.menus[i]);
        }
      });
    });
  },

  methods: {
    toQuestion() {
      let vm = this;
      let portfolios = [];
      for (var menu in this.menus) {
        // console.log(result.MenuRoot.Menu[menu]['$']['text']);
        // console.log(this.menus[menu]);
        for (var sub_menu in this.menus[menu]["SubMenu"]) {
          //   console.log(this.menus[menu]["SubMenu"][sub_menu]["id"]);
          if (this.menus[menu]["SubMenu"][sub_menu]["status"] == true) {
            portfolios.push(this.menus[menu]["SubMenu"][sub_menu]["id"]);
            // console.log(this.menus[menu]["SubMenu"][sub_menu]["status"]);
          }
        }
      }
      // console.log(portfolios);
      let updated_user = this.$store.state.user;
      updated_user.portfolios = portfolios;
      this.$store.dispatch("storeUser", updated_user);
      axios
        .post(
          "http://zorion.alpha-innomed.com:4040/api/user/update",
          updated_user
        )
        .then(function (response) {
          // handle success
          window.location.href = "#/marketsegs";
        })
        .catch(function (error) {
          // handle error
          vm.$store.dispatch("clearToken");
          vm.$store.dispatch("clearUser");
          vm.$router.push({ name: "register" });
        });
    },
    toBack() {
      // window.location.href = "#/account";
    },
    clickSubMenu(data) {
      for (var menu in this.menus) {
        // console.log(result.MenuRoot.Menu[menu]['$']['text']);
        // console.log(this.menus[menu]);
        for (var sub_menu in this.menus[menu]["SubMenu"]) {
          //   console.log(this.menus[menu]["SubMenu"][sub_menu]["id"]);
          if (this.menus[menu]["SubMenu"][sub_menu]["id"] == data) {
            this.menus[menu]["SubMenu"][sub_menu]["status"] = !this.menus[menu]["SubMenu"][sub_menu]["status"];
            // console.log(this.menus[menu]["SubMenu"][sub_menu]["status"]);
          }
        }
      }
    },
  },
};
</script>
<style>
.menu {
  border: 0px !important;
  padding: 0 !important;
}
.sub-menu {
  list-style: none;
  border: 0px !important;
  padding: 0 !important;
  /* margin-top: 0px; */
  margin-left: 20px;
  margin-bottom: 0px;
}
.sub-menu.active {
  margin-left: 25px;
}
</style>
